"use client";
import React, { useEffect, useMemo, useState } from 'react';
import { usePathname } from 'next/navigation';
// components
import ResourcePageHero from './ResourcePageHero';
import CardGridContainer from './CardGridContainer';
import VideoSection from './VideoSection';
import { getHashFromUrl, syncActiveCategory } from '@/app/utils/commonUtils';

const ResourcePageContent = ({ data }: { data: any }) => {
    const { resourcePageHeroContent, blogSectionList, caseStudySectionList, podcastSectionList, videoSection } = data;
    const pathname = usePathname();

    const [activeCategory, setActiveCategory] = useState('');

    useEffect(() => {
        syncActiveCategory(pathname, setActiveCategory);
    }, [pathname]);

    useEffect(() => {
        const hashChangeHandler = () => {
            const hash = getHashFromUrl();
            if (hash) {
                setActiveCategory(hash);
            }
        }

        window.addEventListener('hashchange', hashChangeHandler);

        return () => {
            window.removeEventListener('hashchange', hashChangeHandler);
        }
    }, [])

    const currentSection = useMemo(() => {
        switch (activeCategory) {
        case 'caseStudy':
            return <CardGridContainer data={caseStudySectionList} />;
        case 'blog':
            return <CardGridContainer data={blogSectionList} />;
        case 'podcast':
            return <CardGridContainer data={podcastSectionList} />;
        case 'video':
            return <VideoSection data={videoSection} />;
        default:
            return <></>;
        }
    }, [activeCategory]);
    
    
    return (
        <div style={{fontFamily: 'Inter'}}>
            <ResourcePageHero data={resourcePageHeroContent} />
            {currentSection}
        </div>
    )
}

export default ResourcePageContent;